import React, { useEffect, useState } from 'react';
import style from './style.module.css';
import BoardIcon2 from 'assets/img/board-icon2.svg';
import PinIcon from 'assets/img/PinIcon.svg';
import dotsThreeIcon from 'assets/img/DotsThree.svg';
import { Dropdown } from 'react-bootstrap';
import appToast, { TOAST_TYPE } from 'utils/AppToast';
import SaveModalKanban from 'components/SaveModalKanban';
import APIServices from 'services/APIServices';
import ConfirmModal from 'components/ConfirmModal';
import boardToast from 'pages/projects/kanban/utils/boardToast';

import unpin from 'assets/img/unpin.svg';
import rename from 'assets/img/rename.svg';
import cross3 from 'assets/img/cross3.svg';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <div
    ref={ref} // <-- Pass ref to the element
    style={{ cursor: 'pointer', padding: '0px 10px', zIndex: '1' }}
    onClick={(e) => {
      e.stopPropagation();
      onClick(e);
    }}>
    {children}
  </div>
));

export default function CardWithIcon({
  img,
  projectId,
  title,
  onClick,
  isProjectRelatedBoard,
  childBoardCount,
  fetchProjects,
  openDropdownId,
  setOpenDropdownId,
  fetchProjectsforArchive,
  isArchiveActive,
  initialPinned = false,
  setProjects
}) {
  // const [isEditing, setIsEditing] = useState(false);
  const [editProjectShow, setEditProjectShow] = useState(false);
  const [editableTitle, setEditableTitle] = useState(title);
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [isSaving, setSaving] = useState(false);
  const [isPinned, setIsPinned] = useState(initialPinned);

  useEffect(() => {
    setIsPinned(initialPinned);
  }, [initialPinned]);

  const handleToggle = (isOpen) => {
    if (isOpen) {
      setOpenDropdownId(projectId); // open this dropdown
    } else {
      setOpenDropdownId(null); // close
    }
  };
  const confirmEditTitle = async () => {
    if (editableTitle != title) {
      setIsEditingTitle(true);
      try {
        let response = await APIServices.put(`/project-board/${projectId}`, {
          workspaceName: editableTitle
        });
        if (response.message) {
          appToast(response.message, TOAST_TYPE.SUCCESS);
          fetchProjects();
          setIsEditingTitle(false);
          setEditProjectShow(false);
        } else {
          appToast(response.data.message, TOAST_TYPE.ERROR);
          setIsEditingTitle(false);
          setEditProjectShow(false);
        }
      } catch (error) {
        console.error('Error deleting Member:', error);
        appToast('Failed to delete Member', TOAST_TYPE.ERROR);
        setIsEditingTitle(false);
        setEditProjectShow(false);
      }
    } else {
      setIsEditingTitle(false);
      setEditProjectShow(false);
    }
  };

  const handleArchiveRestoreBoard = async () => {
    try {
      setSaving(true);
      const formData = new FormData();
      // formData.append('boardImage', undefined); // must pass blob + filename
      formData.append('action', false ? 'restore' : 'archive');
      formData.append('isWorkSpace', 'true');

      // Make the POST request
      let response = await APIServices.post(`/project-board/${projectId}/archive`, formData, {
        'Content-Type': 'multipart/form-data'
      });
      if (response?.message) {
        boardToast(response.message, TOAST_TYPE.SUCCESS);
        // fetchProjectsforArchive();
        await fetchProjects();
        setShowConfirm(false);
      } else {
        throw new Error(response?.data?.message || response?.data?.error || 'Failed to close workspace');
      }
    } catch (err) {
      console.error('Error closing workspace:', err);
      boardToast(
        err?.response?.data?.message || err?.response?.data?.error || err?.message || 'Failed to close workspace',
        TOAST_TYPE.ERROR
      );
    } finally {
      setSaving(false);
    }
  };

  const handlePinToggle = async (e) => {
    e.stopPropagation(); // don’t trigger card click
    try {
      setSaving(true);
      let response = await APIServices.post(`/project-board/pin/${projectId}`);
      if (response?.message) {
        boardToast(response.message, TOAST_TYPE.SUCCESS);
        setIsPinned((prev) => !prev); // toggle UI
        fetchProjects(); // refresh list
        setOpenDropdownId(null);
      }
    } catch (err) {
      console.error('Error pin/unpin:', err);
      boardToast('Failed to update pin state', TOAST_TYPE.ERROR);
    } finally {
      setSaving(false);
    }
  };

  const archiveConfirmContent = (
    <>
      <h2 className="mb-3">Are you sure?</h2>
      <h3>
        You want to {/* {isArchivedActive ? 'restore' : 'close'}  */}
        close this board?
      </h3>
    </>
  );

  return (
    <>
      <div className="card-box cursor_pointer" onClick={onClick}>
        <div className="inner-card-box mheight-80">
          <h3>{editableTitle}</h3>
          {isPinned && <img src={PinIcon} alt="Chat Icon" className="pincard_icon" />}
        </div>
        <div className="card-bottom">
          <div className="comment-content">
            <div className="d-flex align-items-center">
              <div className="comment-chat">
                <img src={BoardIcon2} alt="Chat Icon" />
              </div>
              <h5>{childBoardCount > 0 ? childBoardCount : 'Oops… no boards here yet!'}</h5>
            </div>
            <div className="d-flex gap-1 projectcard-bottom-section">
              {isProjectRelatedBoard && <button className="project-btn">Project</button>}
              <Dropdown
                onClick={(e) => {
                  e.stopPropagation(); // Prevent bubbling to card
                }}
                show={openDropdownId === projectId} // controlled
                onToggle={handleToggle}>
                <Dropdown.Toggle as={CustomToggle} id={`dropdown-${projectId}`}>
                  <img src={dotsThreeIcon} alt="menu" />
                </Dropdown.Toggle>

                <Dropdown.Menu
                  onClick={(e) => {
                    e.stopPropagation();
                  }}>
                  <Dropdown.Item onClick={handlePinToggle}>
                     <img
              src={unpin}
              alt="unpin"
              className="featherdrowpdown-icon"
            />
                    {isPinned ? 'Unpin' : 'Pin'}</Dropdown.Item>
                  <Dropdown.Item eventKey="edit" onClick={() => setEditProjectShow(true)}>
                      <img
              src={rename}
              alt="rename"
              className="featherdrowpdown-icon"
            />
                    Rename
                  </Dropdown.Item>
                  {!isArchiveActive && (
                    <Dropdown.Item eventKey="edit" onClick={() => setShowConfirm(true)}>
                       <img
              src={cross3}
              alt="cross3"
              className="featherdrowpdown-icon"
            />
                      Close
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
      <SaveModalKanban
        show={editProjectShow}
        onHide={() => {
          setEditProjectShow(false);
          setEditableTitle(title);
        }}
        isCreateBoard={true}
        isEditingBoard={true}
        onSave={() => {
          confirmEditTitle();
        }}
        title={editableTitle}
        onTitleChange={setEditableTitle}
        isLoading={isEditingTitle}
      />
      <ConfirmModal
        show={showConfirm}
        onHide={() => {
          setShowConfirm(false);
        }}
        confirmationText={archiveConfirmContent}
        handleAction={handleArchiveRestoreBoard}
        closeText="Yes"
        loading={isSaving}
        bgClassname={'whitebgmodal'}
      />
    </>
  );
}
